import React from 'react';

interface HotelProfileMetaProps {
  hotelId: string;
  hotelName: string;
  description?: string;
  images?: string[];
  address?: string | null;
  facilities?: string[];
}

const HotelProfileMeta: React.FC<HotelProfileMetaProps> = ({ hotelId, hotelName, description, images, address, facilities }) => (
  <>
    <meta itemProp="identifier" content={hotelId} />
    <meta itemProp="name" content={hotelName} />
    {description && <meta itemProp="description" content={description} />}
    {images?.map((url) => <meta key={url} itemProp="image" content={url} />)}
    {address && <meta itemProp="address" content={address} />}
    {facilities?.map((name) => (
      <div key={name} itemProp="amenityFeature" itemScope itemType="https://schema.org/LocationFeatureSpecification">
        <meta itemProp="name" content={name} />
        <meta itemProp="value" content="True" />
      </div>
    ))}
  </>
);

export default HotelProfileMeta;
